import api from './api';

const request = async (config) => {
  const result = await api.request(config);
  if (!result?.isSuccess) throw new Error(result?.resultMessage || 'İşlem tamamlanamadı.');
  return result.data;
};

export const getPressCoverage = (params, signal) => request({ method: 'get', url: '/api/press-coverage/admin', params, signal });
export const savePressCoverage = (data) => request({ method: data.guid ? 'put' : 'post', url: `/api/press-coverage${data.guid ? `/${data.guid}` : ''}`, data });
export const deletePressCoverage = (guid) => request({ method: 'delete', url: `/api/press-coverage/${guid}` });

export const readPressImage = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => resolve(reader.result);
  reader.onerror = () => reject(new Error('Görsel okunamadı.'));
  reader.readAsDataURL(file);
});
